export default "__VITE_ASSET__BAi$RtvW__"